import {login_en,login_zh} from "./login/index"
import {home_en,home_zh} from "./home/index"
import {arh_en,arh_zh} from "./arh999/index"
import {Bian_en,Bian_zh} from "./BiAnController/index"
import {aside_en,aside_zh} from "./aside/index"
import {help_en,help_zh} from "./help/index"
import {asideEth_en,asideEth_zh} from "./asideEth/index"
import {introduction_zh,introduction_en} from "./introduce/index"
import {MessageBoard_zh,MessageBoard_en} from "./MessageBoard/index"
import {subscribe_zh,subscribe_en} from "./subscribe/index"
import {formula_zh,formula_en} from "./formula/index"
import {pay_zh,pay_en} from "./pay/index"
import {asideMacroscopic_zh,asideMacroscopic_en} from "./asideMacroscopic/index"
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'


export default {
    zh: {
      // 传入element相关模块
      ...elementZhLocale,
      // 自定义国际化对象引入
      ...login_zh,
      ...home_zh,
      ...arh_zh,
      ...Bian_zh,
      ...aside_zh,
      ...asideEth_zh,
      ...introduction_zh,
      ...MessageBoard_zh,
      ...help_zh,
      ...pay_zh,
      ...subscribe_zh,
      ...formula_zh,
      ...asideMacroscopic_zh,
   


    },
  
    en: {
      // 传入element相关模块
      ...elementEnLocale,
      // 自定义国际化对象引入
      ...login_en,
      ...home_en,
      ...arh_en,
      ...Bian_en,
      ...aside_en,
      ...asideEth_en,
      ...introduction_en,
      ...MessageBoard_en,
      ...help_en,
      ...pay_en,
      ...subscribe_en,
      ...formula_en,
      ...asideMacroscopic_en,
     

   
    },
   
  };